import styled, { createGlobalStyle } from 'styled-components';
import { palette } from 'styled-theme';

import bold from '../../../assets/font/Satoshi-Bold.ttf';
import italic from '../../../assets/font/Satoshi-Medium.ttf';
import regular from '../../../assets/font/Satoshi-Regular.ttf';
import CalendarIcon from '../../../assets/PNG/calendarIcon.png';

export const AppHolder = styled.div`
  @font-face {
    font-family: 'Space Grotesk Regular';
    src: url(${regular});
    font-weight: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Space Grotesk Italic';
    src: url(${italic});
    font-weight: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Space Grotesk Bold';
    src: url(${bold});
    font-weight: normal;
    font-display: fallback;
  }

  font-family: 'Space Grotesk Regular';
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
`;

export const ThemedGlobalStyle = createGlobalStyle`
html {
  width:100vw;
  height:100vh;
  scroll-behavior: smooth;
  
}
  body {
   width:100%;
   height:100%;
    background-color: ${palette('background', 0)};
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  a,
  p,
  li,
  input,
  textarea,
  span,
  div,
  img,
  th,
  td,
  svg {
    margin: 0;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  input[type="date"] { 
    position: relative;  
  }
  input[type="date"]::-webkit-calendar-picker-indicator {
      color: transparent;
      background: none;
      z-index: 1;
      bottom: 0;
      cursor: pointer;
      height: auto;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      width: auto;
  }
  input[type="date"]:before {
      content: url(${CalendarIcon});
      position: absolute;
      right: 10px;
      writing-mode: vertical-lr;
  }
`;
